import React, { PropsWithChildren } from 'react';

import Popover from './Popover';
import Text from './Text';

const TABLE_CELL_TOOLTIP_MAX_CHARS = 313;

const TABLE_CELL_TOOLTIP_BOX_SHADOW = '0px 8px 24px 0px rgba(0, 0, 0, 0.12)';

function stripHtml(html: string): string {
  return html.replace(/(<([^>]+)>)/gi, '').trim();
}

function truncateForTooltip(plainText: string, maxChars: number): string {
  const trimmed = plainText.trim();
  if (trimmed.length <= maxChars) return trimmed;
  return `${trimmed.slice(0, maxChars)}…`;
}

export interface Props {
  text: string;
}

const TableCellTooltip: React.FC<PropsWithChildren<Props>> = ({ text, children }) => {
  const plainText = stripHtml(text);
  const hasContent = plainText.length > 0;

  if (!hasContent) {
    return <>{children}</>;
  }

  const truncatedText = truncateForTooltip(plainText, TABLE_CELL_TOOLTIP_MAX_CHARS);

  return (
    <Popover
      content={
        <Text size="body-xs" color="gray-600" wrap>
          {truncatedText}
        </Text>
      }
      color="white"
      isTooltip
      strategy="fixed"
      placement="bottom"
      offset={[0, 6]}
      maxWidth={316}
      className="TableCellTooltip"
      popoverStyle={{
        borderRadius: 8,
        boxShadow: TABLE_CELL_TOOLTIP_BOX_SHADOW
      }}
    >
      {children}
    </Popover>
  );
};

export default TableCellTooltip;
